import { animate, animation, keyframes, style } from '@angular/animations';

export const incomingAnimation = animation([
  style({
    opacity: 0,
  }),
  animate(
    '4900ms ease',
    keyframes([
      style({
        opacity: 0,
        offset: 0,
        transform: 'scale(2) rotate(35deg)',
      }),
      style({
        opacity: 1,
        offset: 0.1,
        transform: 'scale(1.4) rotate(0)',
      }),
      style({
        offset: 1,
        transform: 'scale(1) rotate(0)',
      }),
    ]),
  ),
]);
